import { Injectable } from '@angular/core';
import {TextFilterComponent} from '../components/filter-controls/text-filter/text-filter.component';
import {NumberFilterComponent} from '../components/filter-controls/number-filter/number-filter.component';
import {DateFilterComponent} from '../components/filter-controls/date-filter/date-filter.component';
import {TimeFilterComponent} from '../components/filter-controls/time-filter/time-filter.component';
import {EnumFilterComponent} from '../components/filter-controls/enum-filter/enum-filter.component';
import {DaterangeFilterComponent} from '../components/filter-controls/daterange-filter/daterange-filter.component';
import {BooleanFilterComponent} from '../components/filter-controls/boolean-filter/boolean-filter.component';


import { FilterControlParams } from '../interfaces/filter-control-params';
import * as _moment from 'moment';
const moment = _moment;

@Injectable({
  providedIn: 'root'
})

export class FilterBuilderService {

  readonly formFieldComponents = {
    string: TextFilterComponent,
    number: NumberFilterComponent,
    date: DateFilterComponent,
    time: TimeFilterComponent,
    enum: EnumFilterComponent,
    daterange: DaterangeFilterComponent,
    bool: BooleanFilterComponent
  };

  constructor() { }

  public setFilterControlValue([key, value]: [string, string], control: FilterControlParams): boolean {

    const {type, name, params, compactValue} = control;
    const lowerName = name.trim().toLowerCase();
    const lowerKey = key.trim().toLowerCase();
    const optionsKeyword = params.optionsKeyword ? params.optionsKeyword.trim().toLowerCase() : 'nothing';


    if (lowerName.includes(lowerKey) || lowerKey.includes(lowerName) || lowerKey.includes(optionsKeyword)) {
      if (type === 'daterange') {
        const altKey = key.includes('start') ? 'start' : 'end';
        if (compactValue) {
          control.compactValue = {
            ...compactValue,
            [altKey]: value,
          };
        } else {
          control.compactValue = {
            [altKey]: value
          };
        }
      } else if (type === 'enum' || type === 'date' || type === 'time') {

        control.compactValue = value;
      } else if (type === 'bool') {
        if (value === 'true') {
          control.value = true;
        } else if (value === 'false') {
          control.value = false;
        }
      } else {
        control.value = value;
      }

      return true;
    }

    return false;
  }

  public createFilterControl([key, value]: [string, string]): FilterControlParams {

    let type = value;
    const name = key;
    const isEnum = value.includes('enum');
    const component = isEnum ? this.formFieldComponents.enum : this.formFieldComponents[value];
    let params = {};

    if (isEnum) {
      type = 'enum';
      const optionsKeyword = value.replace('enum_', '');
      params = {
        optionsKeyword
      };
    }

    return {
      name,
      value: null,
      component,
      params,
      type,
    };

  }

  public mapSearchByFields(params, target = {}) {

    Object.keys(params).forEach(key => {
      if (
        (typeof params[key] === 'string' && params[key].length) ||
        (typeof params[key] === 'number') ||
        (typeof params[key] === 'boolean')
      ) {
        if (params[key] === null) {
          return;
        } else {
          target[key] = params[key];
        }
      } else if (params[key] instanceof Date) {
        target[key] = moment(params[key]).format('YYYY-MM-DD');
      } else if (Array.isArray(params[key]) && params[key].length) {
        let idKey;

        const firstItem = params[key][0];
        const firstItemKeys = Object.keys(firstItem);

        for (const item of firstItemKeys) {
          if (item.toLowerCase().includes('id')) {
            idKey = item;
            break;
          }
        }

        const ids = [];
        params[key].forEach(item => {
          ids.push(item[idKey]);
        });

        target[idKey] = ids.join(',');
      }
    });

    return target;
  }

}
